import {
  trigger,
  transition,
  style,
  query,
  group,
  animate,
  animateChild
} from '@angular/animations';

export const routeAnimations = trigger('routeAnimations', [
  transition('* <=> *', [
    group([


      query(':enter', [
        style({
          opacity: 0,
          transform: 'translateY(16px)',
          willChange: 'transform, opacity'
        }),
        animate('340ms ease-out', style({
          opacity: 1,
          transform: 'translateY(0)'
        }))
      ], { optional: true })
    ])
  ])


]);

export const fadeAnimation = trigger('fadeAnimation', [
  transition('* <=> *', [
    query(':enter', [
      style({ opacity: 0 })
    ], { optional: true }),

    query(':leave', [
      animate('200ms', style({ opacity: 0 }))
    ], { optional: true }),

    query(':enter', [
      animate('400ms 100ms', style({ opacity: 1 }))
    ], { optional: true })
  ])
]);

export const slideAnimation = trigger('slideAnimation', [
  transition('* => *', [
    query(':enter, :leave', [
      style({
        position: 'absolute',
        width: '100%'
      })
    ], { optional: true }),

    group([
      query(':leave', [
        animate('300ms ease-in', style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }))
      ], { optional: true }),

      query(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(100%)'
        }),
        animate('300ms 100ms ease-out', style({
          opacity: 1,
          transform: 'translateX(0%)'
        }))
      ], { optional: true })
    ])
  ])
]);
